import { Vector2 } from 'three';

import { Point2D } from './types';

export const newVector2 = (point2D: Point2D) => new Vector2(point2D.x, point2D.y);
